import React, { Component } from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";
import "../../styles/activate-account.css";
import InvitionApis from "@/helper/invite.api";
import { toast } from "react-toastify";
import {
  FacebookShareButton,
  TwitterShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  FacebookIcon,
  XIcon,
  TelegramIcon,
  WhatsappIcon,
} from "react-share";
import { MdOutlineContentCopy } from "react-icons/md";

class ClanInvite extends Component {
  invitionApis = new InvitionApis();
  baseUrl =
    window.location.hostname === "localhost"
      ? import.meta.env.VITE_APP_WEB_URL
      : window.location.origin;

  constructor(props) {
    super(props);
    this.state = {
      selectedRole: props.inviteAs || props.role || "admin",
      invitationLink: null,
      inviteType: props.inviteType,
    };
  }

  componentDidMount() {
    this.generateInviteLink();
  }

  generateInviteLink() {
    let payload = {};
    if (this.props.inviteType === "clan") {
      payload = {
        contextId: this.props.clanId,
        role: this.state.selectedRole,
        type: "clan",
      };
    } else {
      payload = {
        contextId: this.props.teamId,
        role: this.state.selectedRole,
        type: "team",
      };
    }

    this.invitionApis.getInviteWebUrl(this.props.inviteType, payload).then(res => {
      if (res?.data) {
        const invitationLink = res.data.result;
        this.setState({ invitationLink });
      }
    });
  }

  /**
   * @deprecated
   */
  generateInvitationLink = () => {
    let invitationLink;
    if (this.props.inviteType === "clan") {
      invitationLink = `${this.baseUrl}/?joinClanId=${this.props.clanId}&role=${this.state.selectedRole}`;
    } else {
      invitationLink = `${this.baseUrl}/?joinTeamId=${this.props.teamId}&role=${this.state.selectedRole}`;
    }
    this.setState({
      invitationLink: invitationLink,
    });
  };

  copyLinkToClipBoard = e => {
    e.preventDefault();
    navigator.clipboard.writeText(this.state.invitationLink);
    toast.success("Invitation link has been copied to the clipboard.");
  };

  renderSocialShare = () => {
    let inviteText = `Join Espotz ${this.props.inviteType} named ${this.props.name} as ${this.state.selectedRole} using this link :`;

    return (
      <div>
        <div className="d-flex justify-content-center my-2">
          <div className="d-flex align-items-center w-50 mb-0">
            <p className="flex-grow-1 bg-white my-auto" style={{ height: "1px" }}></p>
            <p className="fs-14 fw-normal text-white-50 mx-2 my-0">OR</p>
            <p className="flex-grow-1 bg-white my-auto" style={{ height: "1px" }}></p>
          </div>
        </div>
        <div className="text-center">
          <WhatsappShareButton
            className="px-1"
            url={this.state.invitationLink}
            quote={inviteText}
            title={inviteText}
          >
            <WhatsappIcon size={"2rem"} round={true} />
          </WhatsappShareButton>

          <FacebookShareButton className="px-1" url={this.state.invitationLink} title={inviteText}>
            <FacebookIcon size={"2rem"} round={true} />
          </FacebookShareButton>

          <TelegramShareButton className="px-1" url={this.state.invitationLink} title={inviteText}>
            <TelegramIcon size={"2rem"} round={true} />
          </TelegramShareButton>

          <TwitterShareButton className="px-1" url={this.state.invitationLink} title={inviteText}>
            <XIcon size={"2.5rem"} round={true} />
          </TwitterShareButton>
        </div>
      </div>
    );
  };

  render() {
    return (
      <>
        <div className="p-3">
          <IoIosCloseCircleOutline
            className="close-icon position-absolute"
            style={{ right: "25px", top: "20px" }}
            onClick={() => {
              this.props.onClick("openClanInvite");
            }}
          />
          <p className="fs-20 fw-600 text-center text-white mb-0">Invite</p>
          <div id="link-section">
            <p className="fw-600 fs-12 text-center text-white-50 mt-4">
              You can Invite the {`${this.state.selectedRole} `}
              for this {this.state.inviteType} by sharing the given link below.
            </p>
            <p className="fs-16 fw-600 text-white mb-1">Copy Link</p>
            <div className="d-flex align-items-center">
              <input
                type="text"
                autoComplete="off"
                className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                placeholder={this.baseUrl}
                value={this.state.invitationLink}
                onChange={e => {}}
                style={{ paddingRight: "35px" }}
              />
              <MdOutlineContentCopy
                className="text-white me-3 position-absolute"
                style={{ right: "10px" }}
                onClick={e => this.copyLinkToClipBoard(e)}
              />
            </div>
            {this.renderSocialShare()}
          </div>
        </div>
      </>
    );
  }
}

export default ClanInvite;
